module.exports = __webpack_public_path__ + "img/extract_hit_dark.f101f79e.png";